import { Button } from 'antd';
import { useRef } from 'react';
const FileInput = ({
  accept,
  multiple,
  children,
  onChange = () => {},
  ...buttonProps
}) => {
  const ref = useRef();
  return <>
			<input ref={ref} style={{
      display: 'none'
    }} type="file" accept={accept} multiple={multiple} onChange={() => onChange(ref.current.files)} />
			<Button {...buttonProps} onClick={() => ref.current.click()} data-sentry-element="Button" data-sentry-source-file="FileInput.jsx">
				{children}
			</Button>
		</>;
};
export default FileInput;